"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneSurfaceCanvas = void 0;
var renderer_scene_canvas_1 = require("@moonpig/renderer-scene-canvas");
var react_1 = __importStar(require("react"));
var renderer_provider_1 = require("../renderer-provider");
var SceneSurfaceCanvas = function (_a) {
    var data = _a.data, size = _a.size, textLayoutsById = _a.textLayoutsById, backgroundColor = _a.backgroundColor, textOnly = _a.textOnly, debugOverlay = _a.debugOverlay, hideObject = _a.hideObject;
    var resourceContext = (0, renderer_provider_1.useRendererContext)().resourceContext;
    var canvasRef = (0, react_1.useRef)(null);
    // Workaround for 'Total canvas memory use exceeds the maximum limit' issue in iOS Safari
    // (more context: https://jira.moonpig.com/browse/ED-1519)
    (0, react_1.useLayoutEffect)(function () {
        return function () {
            var canvas = canvasRef.current;
            canvas.width = 0;
            canvas.height = 0;
        };
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        var render = function () {
            var canvas = canvasRef.current;
            var ctx = canvas.getContext('2d');
            /* istanbul ignore next */
            if (!ctx) {
                throw new Error('Failed to create 2D canvas context');
            }
            var scale = size.width / data.scene.width;
            canvas.width = size.width;
            canvas.height = size.height;
            (0, renderer_scene_canvas_1.renderScene)({
                createCanvas: function (width, height) {
                    var newCanvas = document.createElement('canvas');
                    newCanvas.width = width;
                    newCanvas.height = height;
                    return newCanvas;
                },
                ctx: ctx,
                scene: data.scene,
                scale: scale,
                resourceScale: 1,
                getImage: function (imageUrl) {
                    return resourceContext.getImage(imageUrl).imageElement;
                },
                getFont: function (fontUrl) {
                    return resourceContext.getFont(fontUrl);
                },
                getTextLayout: function (id) {
                    return textLayoutsById[id];
                },
                backgroundColor: backgroundColor,
                textOnly: textOnly,
                debugOverlay: debugOverlay,
                hideObject: function (object) {
                    return hideObject ? hideObject({ object: object }) : false;
                },
            });
        };
        render();
    }, [
        size.width,
        size.height,
        data.scene,
        backgroundColor,
        textOnly,
        debugOverlay,
        hideObject,
    ]);
    return (react_1.default.createElement("canvas", { "data-testid": "mp-renderer-canvas", ref: canvasRef, style: {
            width: '100%',
            height: '100%',
        } }));
};
exports.SceneSurfaceCanvas = SceneSurfaceCanvas;
